import React, { Component } from 'react'
import { Field, reduxForm, getFormValues, change, formValueSelector, initialize } from 'redux-form';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';

import Link from '../../Link';
import Loader from '../../Common/Loader';
import ImageUploadComponent from '../../ImageUploadComponent/ImageUploadComponent';

import messages from '../../../locale/messages';
import validate from './validate';
import submit from './submit'
import { updateTempImages } from '../../../actions/siteadmin/TempImages/updateTempImages';
import { api, categoryUploadDir } from '../../../config';

import defaultIcon from '../../../../public/Icons/defalutImage.svg';

import s from './AddCategoryForm.css';
import bt from '../../../components/commonStyle.css';

export class AddCategoryForm extends Component {
    static defaultProps = {
        currency: 'UGX',
        loading: false
    };
    UNSAFE_componentWillMount() {
        const { initialize } = this.props;
        initialize({ riderFeeType: 'percentage', driverFeeType: 'percentage', isActive: "true" })
    }
    renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder }) => {
        const { formatMessage } = this.props.intl;
        return (
            <Form.Group>
                <label className={bt.labelText} >{label}</label>
                <Form.Control {...input} placeholder={placeholder} type={type} className={bt.formControlInput} />
                {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
            </Form.Group>
        )
    }
    renderFieldDiscount = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder }) => {
        return (
            <div className={'inputFormAddon'}>
                <Form.Group>
                    <label className={bt.labelText} >{label}</label>
                    <InputGroup>
                        <Form.Control {...input} placeholder={placeholder} type={type} className={"formControlInputWithAddon"} />
                        <InputGroup.Append>
                            <InputGroup.Text className="postfixAppendText">%</InputGroup.Text>
                        </InputGroup.Append>
                    </InputGroup>
                    {touched && error && <span className={bt.errorMessage}>{error.defaultMessage}</span>}
                </Form.Group>
            </div>
        )
    }


    handleDropzone = async (fileName, filedName) => {
        const { change, updateTempImages } = this.props;
        await change(filedName, fileName);
        await updateTempImages('Category', filedName, fileName);
    }

    render() {
        const { handleSubmit, currency, categoryImage, categoryMarkerImage, loading, submitting } = this.props;
        const { categoryImageLoader, categoryMarkerImageLoader } = this.props;
        const { formatMessage } = this.props.intl;
        let categoryIcon, categoryMapMarker;
        categoryIcon = categoryImage ? api.apiEndpoint + categoryUploadDir + categoryImage : defaultIcon;
        categoryMapMarker = categoryMarkerImage ? api.apiEndpoint + categoryUploadDir + categoryMarkerImage : defaultIcon;
        return (
            <div className={cx('cardSection', s.widthInner, bt.space5, s.responsiveNoPadding, s.widthInnerTwo, 'bgBlackTwo')}>
                <Row>
                    <Col md={12} lg={12} sm={12} xs={12} className={s.responsiveNoPadding}>
                        <Card className={s.card}>
                            <Form className={s.fullWidth} onSubmit={handleSubmit(submit)} >
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    <h1 className='textAlignRightRTL'>{formatMessage(messages.addCategory)}</h1>
                                </Col>
                                <Row>
                                    <Col lg={6} md={12} sm={6} xs={12}>
                                        <Form.Group className={s.formGroup}>
                                            <div className={cx(s.centerFlex, s.profileImgSection, s.profileImgWidth)}>
                                                <div>
                                                    <ImageUploadComponent
                                                        className={cx(bt.btnPrimary, 'btnPrimaryDark')}
                                                        subTextClass={s.subText}
                                                        subText={formatMessage(messages.maximumUploadSizeLabel)}
                                                        defaultMessage={formatMessage(messages.chooseFile)}
                                                        loaderName={'categoryImageLoader'}
                                                        postUrl={api.apiEndpoint + '/uploadCategoryImage'}
                                                        loader={categoryImageLoader}
                                                        fieldName={'categoryImage'}
                                                        imageSrc={categoryIcon}
                                                        label={formatMessage(messages.categoryIcon)}
                                                        inputContainer={'.dzInputContainer'}
                                                        inputContainerClass={'dzInputContainer'}
                                                        handleDropzone={this.handleDropzone}
                                                        defaultImage={!categoryImage ? true : false}
                                                    />
                                                </div>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6} md={12} sm={6} xs={12}>
                                        <Form.Group className={s.formGroup}>
                                            <div className={cx(s.centerFlex, s.profileImgSection, s.profileImgWidth)}>
                                                <ImageUploadComponent
                                                    className={cx(bt.btnPrimary, 'fileNoPadding', 'btnPrimaryDark')}
                                                    subTextClass={s.subText}
                                                    subText={formatMessage(messages.maximumUploadSizeLabel)}
                                                    defaultMessage={formatMessage(messages.chooseFile)}
                                                    loaderName={'categoryMarkerImageLoader'}
                                                    postUrl={api.apiEndpoint + '/uploadCategoryMarker'}
                                                    loader={categoryMarkerImageLoader}
                                                    fieldName={'categoryMarkerImage'}
                                                    imageSrc={categoryMapMarker}
                                                    label={formatMessage(messages.categoryMapMarker)}
                                                    inputContainerClass={'dzInputContainer'}
                                                    handleDropzone={this.handleDropzone}
                                                    defaultImage={!categoryMarkerImage ? true : false}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={4} md={6} sm={6} xs={12}>
                                        <Form.Group className={s.formGroup}>
                                            <div>
                                                <Field
                                                    name="categoryName"
                                                    type="text"
                                                    placeholder={formatMessage(messages.categoryName)}
                                                    component={this.renderField}
                                                    label={formatMessage(messages.categoryName)}
                                                    labelClass={bt.labelText}
                                                    fieldClass={bt.formControlInput}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={4} md={6} sm={6} xs={12}>
                                        <Form.Group className={s.formGroup}>
                                            <div>
                                                <Field
                                                    name="capacity"
                                                    type="text"
                                                    placeholder={formatMessage(messages.capacity)}
                                                    component={this.renderField}
                                                    label={formatMessage(messages.capacity)}
                                                    labelClass={bt.labelText}
                                                    fieldClass={bt.formControlInput}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={4} md={6} sm={6} xs={12}>
                                        <Form.Group className={s.formGroup}>
                                            <div>
                                                <label className={bt.labelText} >{formatMessage(messages.status)}</label>
                                                <Field name="isActive" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
                                                    <option value={true}>{formatMessage(messages.active)}</option>
                                                    <option value={false}>{formatMessage(messages.inactive)}</option>
                                                </Field>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Col lg={12} md={12} sm={12} xs={12} className={cx(bt.textAlignRight, bt.spaceTop3, 'loadingBtnRTL', 'textAlignLeftRTL')}>
                                    <Form.Group className={s.formGroup}>
                                        <div className={s.displayInlineBlock}>
                                            <Loader
                                                type={"button"}
                                                label={formatMessage(messages.submitButton)}
                                                show={loading}
                                                buttonType={'submit'}
                                                className={cx(bt.btnPrimary)}
                                                disabled={submitting || loading}
                                                isSuffix={true}
                                            />
                                        </div>
                                        <Link to={"/siteadmin/category"} className={cx(s.backBtn, bt.btnSecondary, 'backBtnRTL')} >{formatMessage(messages.goBack)}</Link>
                                    </Form.Group>
                                </Col>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}
AddCategoryForm = reduxForm({
    form: 'AddCategoryForm',
    onSubmit: submit,
    validate
})(AddCategoryForm);
const selector = formValueSelector('AddCategoryForm');
const mapState = (state) => ({
    currency: state.currency,
    categoryImage: selector(state, 'categoryImage'),
    categoryMarkerImage: selector(state, 'categoryMarkerImage'),
    loading: state.loader.AddCategory,
    categoryImageLoader: state.loader.categoryImageLoader,
    categoryMarkerImageLoader: state.loader.categoryMarkerImageLoader
})
const mapDispatch = {
    initialize,
    change,
    updateTempImages
}
export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(AddCategoryForm)));
